import type { LaidOutEdge } from "../../lib/topology";

export function Edge({ edge, active }: { edge: LaidOutEdge; active?: boolean }) {
  return (
    <g className="topology-edge">
      <line
        x1={edge.sourceX} y1={edge.sourceY}
        x2={edge.targetX} y2={edge.targetY}
        stroke={active ? "var(--color-secondary)" : "var(--color-border)"}
        strokeWidth="1"
      />
      {active ? (
        <circle r="2" fill="var(--color-text-accent)">
          <animateMotion
            dur="2s"
            repeatCount="indefinite"
            path={`M${edge.sourceX},${edge.sourceY} L${edge.targetX},${edge.targetY}`}
          />
        </circle>
      ) : null}
    </g>
  );
}
